module.exports = __webpack_public_path__ + "img/block-brawler-logo.430b7474.png";